// extracted by mini-css-extract-plugin
export default {"headerBar":"ReportHelp_headerBar__p1igo"};